import { mapState } from 'vuex'
import FixFluidColGrid from '@/components/fix-fluid-col-grid/fix-fluid-col-grid.vue'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import TableCustomSort from '@/components/table-custom-sort/table-custom-sort'
import FiltersSelect from '@/components/filters-select/filters-select.vue'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'OrderTable',
  components: {
    FixFluidColGrid,
    Scrollbar,
    TableCustomSort,
    FiltersSelect
  },
  props: {
    orderList: {
      /**
       * Array<{
       *   order_id: number,
       *   cost: number,
       *   payment_type: string,
       *   client: { name: string, phone: string, address: string }
       *   datetime_created: string,
       *   datetime_delivery_date: string,
       *   datetime_completed: string,
       *   courier: { courier_id: number, first_name: string, last_name: string, native: boolean },
       *   canceled: boolean
       * }>
       */
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filters: {
        paymentType: null,
        courier: null,
        canceled: false
      },
      columns: [
        {
          label: '№ заказа',
          field: 'order_id',
          type: 'number',
          sortable: false
        },
        {
          label: 'Клиент',
          field: 'client.name',
          type: 'string',
          sortable: false
        },
        {
          label: 'Телефон',
          field: 'client.phone',
          type: 'string',
          sortable: false
        },
        {
          label: 'Адрес',
          field: 'client.address',
          type: 'string',
          sortable: false,
          tdClass: 'td-address'
        },
        {
          label: 'Время оформления',
          field: 'datetime_created',
          type: 'string',
          sortable: false
        },
        {
          label: 'Время доставки',
          field: 'datetime_delivery_date',
          type: 'string',
          sortFn: this.sortDate,
        },
        {
          label: 'Время оплаты/отмены',
          field: 'datetime_completed',
          type: 'string',
          sortable: false
        },
        {
          label: 'Курьер',
          field: 'courier.last_name',
          type: 'string',
          sortable: false
        },
        {
          label: 'Статус',
          field: 'canceled',
          type: 'boolean',
          sortable: false
        },
        {
          label: 'Способ оплаты',
          field: 'payment_type',
          type: 'string',
          sortable: false
        },
        {
          label: 'Сумма',
          field: 'cost',
          type: 'number'
        },
      ]
    }
  },
  computed: {
    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes
    }),
    paymentTypeOptions() {
      const result =  Object.keys(this.paymentTypes).map(key => ({
        id: key,
        title: this.paymentTypes[key].title
      }))
      return result
    },
    courierOptions() {
      const couriersMap = {}
      this.orderList.forEach(order => {
        if (order.courier) {
          couriersMap[order.courier.courier_id] = {
            ...order.courier,
            id: order.courier.courier_id,
            title: `${order.courier.last_name} ${order.courier.first_name}`
          }
        }
      })
      const result = Object.values(couriersMap)
      return result
    },
    orderListFiltered() {
      return this.orderList.filter(order => {
        
        let paymentTypeCheck = true
        let courierCheck = true
        let canceledCheck = true
        
        if (this.filters.paymentType) {
          paymentTypeCheck = order.payment_type === this.filters.paymentType.id
        }
        if (this.filters.courier) {
          if (order.courier === null) {
            courierCheck = false
          } else {
            courierCheck = order.courier.courier_id === this.filters.courier.id
          }
        }
        if (this.filters.canceled) {
          return canceledCheck = order.canceled
        }
        return paymentTypeCheck && courierCheck && canceledCheck
      })
    }
  },
  methods: {
    numberWithSeparator,
    sortDate(x, y) {
      const xDate = this.$moment(x)
      const yDate = this.$moment(y)
      const diff = xDate.diff(yDate)
      if (diff > 0) {
        return 1
      }
      if (diff < 0) {
        return -1
      }
      return 0
    },
    getCourierName(courier) {
      if (courier) {
        return `${courier.last_name} ${courier.first_name.charAt(0).toUpperCase()}.`
      }
      return ''
    },
    getFormatedSumm(summ) {
      return `${numberWithSeparator(summ)} ₽`
    },
    getFormatPhone(phone) {
      if (phone) {
        const phoneStrPrepared = phone.replace(/[^\d]/g, '')
        return this.$options.filters.phoneFormat(phoneStrPrepared)
      }
      return ''
    },
    onRowClick({ row }) {
      this.$emit('click-order', row)
    }
  }
}